import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { AbstractTuiControl } from '@taiga-ui/legacy';

import { CitySwitcherSize, CitySwitcherItemType, CitySwitcherMode } from './types';
import { CitySwitcherService } from './services';

@Component({
  selector: 'app-city-switcher',
  templateUrl: './city-switcher.component.html',
  styleUrls: ['./city-switcher.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CitySwitcherComponent extends AbstractTuiControl<CitySwitcherItemType> {
  private readonly citySwitcherService = inject(CitySwitcherService);

  @Input() textfieldSize: CitySwitcherSize = 'm';
  @Input() mode: CitySwitcherMode = 'input';

  readonly currentCity$ = this.citySwitcherService.currentCity$;

  get focused(): boolean {
    return false;
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.currentCity$.subscribe(value => (this.value = value));
  }

  protected getFallbackValue(): CitySwitcherItemType {
    return null;
  }

  onCityChange(city: CitySwitcherItemType) {
    this.citySwitcherService.setCurrentCity(city);
  }
}
